import { User } from "../interfaces/user";

export enum UserRoleType {
    SuperAdmin = "Super Admin",
    DealerPrincipleUser = "Dealer Principal/General Manager",
    DepartmentalManager = "Departmental Manager",
    SharedServicesUser = "Shared Services User",
    SharedServicesAdmin = "Shared Services Admin",
    CFO_CEO = "Franchise Managerial",
    Supervisor = "Supervisors",
    Automate_Admin = "Automate Admin",
    RiskUser = "Risk User"
}

export class UserRoleGroups {
    static readonly DealerPrincipleGroup: UserRoleType[] = [
        UserRoleType.SuperAdmin,
        UserRoleType.DealerPrincipleUser,
        UserRoleType.SharedServicesAdmin,
        UserRoleType.Automate_Admin
    ];

    static readonly DepartmentalManagerGroup: UserRoleType[] = [
        UserRoleType.SuperAdmin,
        UserRoleType.DepartmentalManager,
        UserRoleType.SharedServicesUser,
        UserRoleType.SharedServicesAdmin,
        UserRoleType.Automate_Admin
    ];

    static readonly SharedServicesGroup: UserRoleType[] = [
        UserRoleType.SuperAdmin,
        UserRoleType.SharedServicesUser,
        UserRoleType.SharedServicesAdmin,
        UserRoleType.Automate_Admin
    ];

    static readonly SharedServicesAdminGroup: UserRoleType[] = [
        UserRoleType.SuperAdmin,
        UserRoleType.SharedServicesAdmin,
        UserRoleType.Automate_Admin
    ];

    static readonly CEOGroup: UserRoleType[] = [
        UserRoleType.CFO_CEO,
        UserRoleType.Automate_Admin
    ];

    static readonly SuperAdmin: UserRoleType[] = [
        UserRoleType.SuperAdmin,
        UserRoleType.Automate_Admin
    ];

    static readonly RiskUser: UserRoleType[] = [
        UserRoleType.RiskUser
    ]

    static getUserRoleType(user: User): UserRoleType | null {
        return Object.values(UserRoleType).includes(user.RoleName as UserRoleType)
            ? user.RoleName as UserRoleType
            : null;
    }

    static isDealerPrincipleGroup(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.DealerPrincipleGroup.includes(Role) ? true : false;
    }
    static isDepartmentalManagerGroup(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.DepartmentalManagerGroup.includes(Role) ? true : false;
    }
    static isSharedServicesGroup(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.SharedServicesGroup.includes(Role) ? true : false;
    }
    static isCEOGroup(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.CEOGroup.includes(Role) ? true : false;
    }
    static isSuperAdmin(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.SuperAdmin.includes(Role) ? true : false;
    }

    static isSharedServicesAdmin(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.SharedServicesAdminGroup.includes(Role) ? true : false;
    }

    static isRiskUserGroup(): boolean {
        const Role: UserRoleType | null = UserRoleGroups.getUserRoleType(JSON.parse(sessionStorage.getItem('user') ?? '{}'));
        return Role && UserRoleGroups.RiskUser.includes(Role) ? true : false;
    }
} 